export const DATA_DICTIONARY_COPY = {
	CUSTOMIZED_VIEWS_DISPLAYED_HERE: 'Customized Data Dictionary views will be displayed here.',
	DATA_DICTIONARY_HELP_ARTICLE: 'Data Dictionary Help Article',
	FOR_MORE_ON_SAVED_VIEWS: 'For more on saved views, visit the'
};
